import { create } from 'zustand';

type UseFolderTypologyState = {
  isFolder?: boolean;
  direction?: string;
  folderTypologyId?: string;
  setFolderTypologyId: (folderTypology: string) => void;
};

export const useFolderTypologyState = create<UseFolderTypologyState>((set) => ({
  setFolderTypologyId: (folderTypologyId: string) => set(() => ({ folderTypologyId })),
}));
